// Operator contact-submissions inbox strings (auto-merged by lib/i18n.ts).
export const en = {
  'operator.contact_submissions.head': 'Contact form',
  'operator.contact_submissions.title': 'Contact form',
  'operator.contact_submissions.desc': 'Messages submitted through the public contact form.',
  'operator.contact_submissions.empty': 'No open contact submissions.',
  'operator.contact_submissions.resolve': 'Resolve',
  'operator.contact_submissions.resolve_title': 'Resolve this submission?',
  'operator.contact_submissions.resolve_body':
    'It will be marked resolved and removed from the open list.',
  'operator.contact_submissions.resolved': 'Submission resolved.',
  'operator.contact_submissions.status.open': 'Open',
  'operator.contact_submissions.status.resolved': 'Resolved',
}

export const zhTW = {
  'operator.contact_submissions.head': '聯絡表單',
  'operator.contact_submissions.title': '聯絡表單',
  'operator.contact_submissions.desc': '透過公開聯絡表單送出的訊息。',
  'operator.contact_submissions.empty': '沒有待處理的聯絡表單訊息。',
  'operator.contact_submissions.resolve': '標記已處理',
  'operator.contact_submissions.resolve_title': '將此訊息標記為已處理？',
  'operator.contact_submissions.resolve_body': '此訊息將標記為已處理，並自待處理清單移除。',
  'operator.contact_submissions.resolved': '訊息已標記為已處理。',
  'operator.contact_submissions.status.open': '待處理',
  'operator.contact_submissions.status.resolved': '已處理',
}
